import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {FrameworkModule} from "../framework/framework.module";
import {EmployeeSingleSelectSearchControlComponent} from "./employee/controls/employee-single-select-search-control.component";
import {EmployeeReportSelectionControlComponent} from "./employee/controls/employee-report-selection-control.component";
import {EmployeeSingleSelectEditControlComponent} from "./employee/controls/employee-single-select-edit-control.component";
import {EmployeeMultiSelectSearchControlComponent} from "./employee/controls/employee-multi-select-search-control.component";
import {AccessRoleMultiSelectSearchControlComponent} from "./access-role/controls/access-role-multi-select-search-control.component";
import {AccessRoleReportSelectionControlComponent} from "./access-role/controls/access-role-report-selection-control.component";
import {AccessRoleSingleSelectEditControlComponent} from "./access-role/controls/access-role-single-select-edit-control.component";
import {PosuserSingleSelectEditControlComponent} from "./posuser/controls/posuser-single-select-edit-control.component";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule
    ],
    declarations: [
        AccessRoleSingleSelectEditControlComponent,
        AccessRoleMultiSelectSearchControlComponent,
        AccessRoleReportSelectionControlComponent,
        EmployeeSingleSelectSearchControlComponent,
        EmployeeReportSelectionControlComponent,
        EmployeeSingleSelectEditControlComponent,
        EmployeeMultiSelectSearchControlComponent,
        PosuserSingleSelectEditControlComponent
    ],
    exports: [
        AccessRoleSingleSelectEditControlComponent,
        AccessRoleMultiSelectSearchControlComponent,
        AccessRoleReportSelectionControlComponent,
        EmployeeSingleSelectSearchControlComponent,
        EmployeeReportSelectionControlComponent,
        EmployeeSingleSelectEditControlComponent,
        EmployeeMultiSelectSearchControlComponent,
        PosuserSingleSelectEditControlComponent
    ]
})
export class EmployeeSharedModule {
}
